// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"bf5db070","469":"f78f3fd5","725":"13c623ba"}[chunkId] + ".chunk.js";
};